import React from 'react';
import useDeliveriesEventSource from '../../hooks/use-deliveries-event-source';

export const SSEInitializer = ({SSEerror = false}) => {
    useDeliveriesEventSource(SSEerror);
    return <></>
}

